import { Component } from '@angular/core';
import { HelpService } from '@app/services/help.service';

@Component({
  selector: 'app-job-application-profile-modal',
  templateUrl: './job-application-profile-modal.component.html',
  styleUrls: ['./job-application-profile-modal.component.css']
})
export class JobApplicationProfileModalComponent {

  public idJob: Number = 0;
  private modalName = 'modal-invalid-profile';
  constructor(public helpService: HelpService) { }

  setValues(id: Number) {
    this.idJob = id;
    this.helpService.modalShow(this.modalName);
  }
}
